export function formatLabel(key) {
	return String(key || '')
		.replace(/_/g, ' ')
		.replace(/([a-z])([A-Z])/g, '$1 $2')
		.replace(/\b\w/g, c => c.toUpperCase());
}

export function valueToText(value) {
	if (value == null) return '';
	if (Array.isArray(value)) {
		return value.map(item => valueToText(item)).join(', ');
	}
	if (typeof value === 'object') {
		return Object.entries(value)
			.map(([k, v]) => `${k}: ${valueToText(v)}`)
			.join('; ');
	}
	return String(value);
}

// Data-shaping replacement for the old valueToHtml() string-builder — returns
// structured rows for SummaryList.vue to v-for over instead of innerHTML.
// Each row is either a plain-text row or a nested object/list row.
export function valueToDisplayEntries(value) {
	if (value == null) return [];

	if (Array.isArray(value)) {
		if (!value.length) return [];
		if (value.every(item => item == null || typeof item !== 'object')) {
			return [{ type: 'bullet-list', items: value.map(item => valueToText(item)) }];
		}
		return value.map(item => ({ type: 'text', text: valueToText(item) }));
	}

	if (typeof value === 'object') {
		return Object.entries(value).map(([k, v]) => ({
			type: Array.isArray(v) ? 'list' : 'object-row',
			key: k,
			label: formatLabel(k),
			value: v,
			children: Array.isArray(v) ? valueToDisplayEntries(v) : null
		}));
	}

	return [];
}

export function rangeText(range) {
	if (!range || (range.min == null && range.max == null)) return '—';
	if (range.min == null) return '< ' + range.max;
	if (range.max == null) return '> ' + range.min;
	return range.min + '–' + range.max;
}

export function avg(values) {
	const v = values.filter(x => x != null && !isNaN(x));
	if (!v.length) return null;
	return Math.round((v.reduce((a, b) => a + b, 0) / v.length) * 100) / 100;
}

export function fmt(v) {
	return (v == null || v === '') ? '—' : v;
}

export function sampleLabel(s) {
	return s.id || s.lab_number || s.sample_group || 'Sample';
}

const FLAG_CLASS = { LOW: 'flag-low', OPT: 'flag-opt', HIGH: 'flag-high', NOT_TESTED: 'flag-na' };

export function flagClass(f) {
	return FLAG_CLASS[f] || 'flag-na';
}

// Only needed for fields the schema doesn't already return a flag for
// (currently just soluble salts) — everything else uses sample.flags.* as-is.
export function computeFlag(value, range) {
	if (value == null) return 'NOT_TESTED';
	if (!range) return '';
	if (range.min != null && value < range.min) return 'LOW';
	if (range.max != null && value > range.max) return 'HIGH';
	return 'OPT';
}

export function orderEntriesByPreferredKeys(obj, preferredKeys) {
	const entries = Object.entries(obj || {});
	const preferredIndex = new Map(preferredKeys.map((k, i) => [k, i]));

	return entries.sort(([a], [b]) => {
		const aIdx = preferredIndex.has(a) ? preferredIndex.get(a) : Number.MAX_SAFE_INTEGER;
		const bIdx = preferredIndex.has(b) ? preferredIndex.get(b) : Number.MAX_SAFE_INTEGER;
		if (aIdx !== bIdx) return aIdx - bIdx;
		return 0;
	});
}
